export default __webpack_public_path__ + "static/media/eye_on.a1dab03e.svg";